import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { FooterRoutingModule } from './footer-routing.module';
import { FooterListComponent } from './footer-list/footer-list.component';
import { FooterCreateComponent } from './footer-create/footer-create.component';

@NgModule({
  declarations: [FooterListComponent, FooterCreateComponent],
  imports: [
    CommonModule,
    FooterRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class FooterModule { }
